import { Badge } from "@/components/ui/badge";
import { TabsList, TabsTrigger } from "@/components/ui/tabs";

const ACTIVE_TAB_CLASS =
  "data-[state=active]:bg-primary data-[state=active]:text-primary-foreground data-[state=active]:shadow-sm";

export function DashboardTabList({
  showUsersTab = true,
  needsAttentionCount = 0,
  complianceIssueCount = 0,
  showNeedsAttentionTab = true,
  showComplianceIssuesTab = false,
  showUnregisteredTab = true,
  showPaymentsTab = true,
  showInspectionsTab = true,
  showInvoicesTab = true,
  showBalanceDueTab = true,
}: {
  showUsersTab?: boolean;
  needsAttentionCount?: number;
  complianceIssueCount?: number;
  showNeedsAttentionTab?: boolean;
  showComplianceIssuesTab?: boolean;
  showUnregisteredTab?: boolean;
  showPaymentsTab?: boolean;
  showInspectionsTab?: boolean;
  showInvoicesTab?: boolean;
  showBalanceDueTab?: boolean;
}) {
  return (
    <TabsList className="h-auto max-w-full flex-wrap justify-start bg-card [&_[data-slot=tabs-trigger]]:h-8 [&_[data-slot=tabs-trigger]]:flex-none">
      <TabsTrigger className={ACTIVE_TAB_CLASS} value="all">
        <span className="hidden md:block">All Active Registrations</span>
        <span className="block md:hidden">Active</span>
      </TabsTrigger>
      {showComplianceIssuesTab ? (
        <TabsTrigger
          className={`${ACTIVE_TAB_CLASS} data-[state=active]:bg-destructive data-[state=active]:text-white`}
          value="compliance-issues"
        >
          <span className="flex items-center gap-1.5">
            Compliance Issues
            {complianceIssueCount > 0 ? (
              <Badge variant="destructive" className="h-5 px-1.5">
                {complianceIssueCount}
              </Badge>
            ) : null}
          </span>
        </TabsTrigger>
      ) : null}
      {showNeedsAttentionTab ? (
        <TabsTrigger
          className={`${ACTIVE_TAB_CLASS} data-[state=active]:bg-warning data-[state=active]:text-warning-foreground`}
          value="needs-attention"
        >
          <span className="flex items-center gap-1.5">
            Needs Attention
            {needsAttentionCount > 0 ? (
              <Badge variant="warning" className="h-5 px-1.5">
                {needsAttentionCount}
              </Badge>
            ) : null}
          </span>
        </TabsTrigger>
      ) : null}
      {showBalanceDueTab ? (
        <TabsTrigger className={ACTIVE_TAB_CLASS} value="balance-due">
          Balance Due
        </TabsTrigger>
      ) : null}
      <TabsTrigger className={ACTIVE_TAB_CLASS} value="renewable">
        Renewable
      </TabsTrigger>
      <TabsTrigger className={ACTIVE_TAB_CLASS} value="inactive">
        <span className="hidden md:block">Inactive Registrations</span>
        <span className="block md:hidden">Inactive</span>
      </TabsTrigger>
      {showUnregisteredTab ? (
        <TabsTrigger
          className={ACTIVE_TAB_CLASS}
          value="unregistered-properties"
        >
          <span className="hidden lg:block">Unregistered Properties</span>
          <span className="hidden md:block lg:hidden">Unregistered</span>
          <span className="block md:hidden">Unreg.</span>
        </TabsTrigger>
      ) : null}
      {showInvoicesTab ? (
        <TabsTrigger className={ACTIVE_TAB_CLASS} value="invoices">
          Invoices
        </TabsTrigger>
      ) : null}
      {showPaymentsTab ? (
        <TabsTrigger className={ACTIVE_TAB_CLASS} value="payments">
          Payments
        </TabsTrigger>
      ) : null}
      {showInspectionsTab ? (
        <TabsTrigger className={ACTIVE_TAB_CLASS} value="inspections">
          Inspections
        </TabsTrigger>
      ) : null}
      {showUsersTab ? (
        <TabsTrigger className={ACTIVE_TAB_CLASS} value="users">
          Users
        </TabsTrigger>
      ) : null}
    </TabsList>
  );
}
